module.exports = __webpack_public_path__ + "media/images/icon_blog01_19-16-d6ef123624373613d8ca06b7bc2226ac.png";